<template>
  <div class="edit">
    <div class="content">
      <Card>
        <template v-slot:title>
          <p>岗位基本信息</p>
        </template>
        <Form ref="form" :model="job" :rules="rules" :label-width="110">
          <FormItem label="岗位名称：" prop="title">
            <Input v-model="job.title" style="width: 379px" placeholder="请输入岗位名称" :maxlength="50"></Input>
          </FormItem>
          <FormItem label="岗位类型：" prop="positionId">
            <Cascader :data="positions" style="width: 379px" @on-change="setPositon_name" v-model="positionsIds"></Cascader>
          </FormItem>
          <FormItem label="招聘人数：" prop="headCount">
            <InputNumber v-model="job.headCount" style="width: 379px" placeholder="请输入招聘人数"></InputNumber>
          </FormItem>
          <FormItem label="工作地点：" prop="address">
            <Address @choose="chooseLocation" :address="job.address"></Address>
          </FormItem>

          <FormItem label="经验和学历：">
            <Select
              placeholder="选择经验"
              v-model="job.workYearString"
              @on-change="changeWorkYear"
              style="width: 110px; margin-right: 20px"
            >
              <Option v-for="(item, index) in years" :value="item.label" :key="index">{{ item.label }}</Option>
            </Select>
            <Select placeholder="选择学历" v-model="job.degree" style="width: 110px" clearable @on-change="changeDegree">
              <Option v-for="(item, index) in degrees" :value="item.value" :key="index">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="薪资范围：" prop="salaryPer">
            <!-- <Select placeholder="最低" v-model="job.limit_msg" style="width:110px;margin-right:20px">
            <Option
              v-for="(item,index) in pickerList['limit'] && pickerList['limit'].options"
              :value="item"
              :key="index"
            >{{ item }}</Option>
          </Select>-->
            <InputNumber v-if="job.salaryPer" v-model="job.salaryMin" :min="0"></InputNumber>
            <span v-if="job.salaryPer" style="margin: 0 10px">-</span>
            <InputNumber v-if="job.salaryPer" v-model="job.salaryMax" :min="job.salaryMin"></InputNumber>
            <span v-if="job.salaryPer">元 /</span>
            <Select placeholder="计薪周期" v-model="job.salaryPer" style="width: 110px" clearable>
              <Option v-for="(item, index) in salaryPers" :value="item.value" :key="index">{{ item.label }}</Option>
            </Select>
            <!-- <Tag checkable color="red" :checked="isCustom" @click.native="handleCustom">面议</Tag> -->
            <!-- <span class="custom" :class="{ actived: isCustom }"></span> -->
          </FormItem>
          <FormItem label="岗位描述：" prop="jd" style="position: relative">
            <div class="ai-text" @click="aiPopup">
              <img src="@/assets/images/eye.png" style="width: 26px; height: 14px" />
              <span style="color: #f21b18; font-size: 14px; padding-left: 4px">AI帮写</span>
            </div>
            <div class="editor">
              <Input
                :rows="5"
                style="width: 380px"
                placeholder="请输入职务描述"
                ref="editor"
                v-model="job.jd"
                type="textarea"
                :maxlength="20000"
              ></Input>
            </div>
          </FormItem>
          <FormItem label="行业标签：">
            <div class="industry">
              <div v-if="industry.length" class="hot-post-list">
                <div class="post-item zan-ellipsis bill" v-for="(item, index) in industry" :key="index">
                  {{ item.name }}
                </div>
                <div class="arrow-right" v-if="industry.length" @click="selectIndustries">></div>
              </div>
              <Button v-else type="text" @click="selectIndustries">请选择</Button>
            </div>
          </FormItem>
          <FormItem label="新匠人标签：">
            <div class="hot-post-list">
              <div
                @click="selectNewCraftsmanPosition(item)"
                class="post-item zan-ellipsis"
                v-for="(item, index) in new_craftsman_position"
                :key="index"
                :class="{
                  bill: job.featureIds.includes(item.id),
                  'not-done': !job.featureIds.includes(item.id)
                }"
                style="cursor: pointer"
              >
                {{ item.name }}
              </div>
            </div>
          </FormItem>
          <FormItem label="联系人：" prop="contactName">
            <Input v-model="job.contactName" style="width: 379px" placeholder="请输入联系人" :maxlength="20"></Input>
          </FormItem>
          <FormItem label="联系电话：" prop="contactPhone">
            <Input v-model="job.contactPhone" style="width: 379px" placeholder="请输入联系电话(该信息不对求职者直接展示)"></Input>
          </FormItem>
          <FormItem label="邮箱：" prop="contactEmail">
            <Input v-model="job.contactEmail" style="width: 379px" placeholder="请输入邮箱(该信息不对求职者直接展示)"></Input>
          </FormItem>
          <FormItem label="福利待遇：" prop="benefit">
            <Select v-model="job.benefit" multiple>
              <Option v-for="item in benefits" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <div style="margin-top:10px;text-align: center;">
              <Checkbox v-model="jobChecked">
                我已阅读并同意
                <a style="color: red" @click="goAgreement">《岗位协议》</a>
                ，承诺上传的岗位信息真实、合法、准确，遵守平台规定，如有违反，愿承担相应责任。
              </Checkbox>
            </div>
          <FormItem label="">
            <div class="btn" v-if="!this.id">
              <Button :loading="loading" type="default" @click="add(true)" style="margin-right: 20px">暂存</Button>
              <Button :loading="loading" type="primary" @click="add(false)">提交审核</Button>
            </div>
            <div v-else class="btn">
              <!-- <Button type="text" style="margin-right: 20px" @click="clear">删除</Button> -->
              <Button :loading="loading" type="default" @click="confirm(true)" style="margin-right: 20px">暂存</Button>
              <Button :loading="loading" type="primary" @click="confirm(false)" v-if="job.isUnionOpera !== 1">提交审核</Button>
            </div>
          </FormItem>
        </Form>
      </Card>

      <Drawer title="地图" width="500" :closable="true" :mask-closable="false" v-model="oMap">
        <Map @setSite="setSite"></Map>
      </Drawer>
      <Modal
        v-model="dialogVisible"
        footer-hide
        mask-closable
        class="set-bg"
        :closable="false"
        width="815px"
        @on-visible-change="beforeClose"
      >
        <div class="ai-botttom">
          <div class="top">
            <img src="@/assets/images/ai.png" style="width: 30px; height: 23px" />
            <span style="color: #f21b18; font-size: 16px; padding-left: 8px">AI帮写</span>
          </div>
          <div class="prompt" v-if="!aiLoading">请描述:你对这个岗位的候选人其他要求? 例如:行业经验等</div>
          <div class="scroll-item" v-if="answer && !aiLoading">
            <div v-html="answer"></div>
          </div>
          <div class="tips" v-if="!aiLoading">内容由AI生成，仅供参考！</div>
          <div class="loading-img" v-if="aiLoading">
            <img src="@/assets/images/loading.png" style="width: 66px; height: 50px; margin-top: 40px" />

            <div>正在生成中...</div>
          </div>
          <div class="ai-btn-right" v-if="answer && !aiLoading && !disabled">
            <div class="ai-btn" @click="use">确认使用</div>
            <div class="ai-btn btn-left" @click="repeat">重新生成</div>
          </div>
          <div class="input" v-if="!aiLoading && !disabled">
            <div class="foot_center">
              <Input
                v-model="keyword"
                placeholder="告诉AI你对职位描述的要求"
                size="large"
                style="width: 718px"
                :disabled="disabled"
                class="ai-input"
                :border="false"
                type="textarea"
                :maxlength="20000"
                :rows="1"
              />
              <Button type="primary" @click="aiInput" class="btn_foot">发送</Button>
            </div>
          </div>
        </div>
      </Modal>
      <IndustryModal ref="industryModal" @onConfirm="initIndustries" />
    </div>
  </div>
</template>

<script>
import editor from '@/components/editor/editor';
import Map from '@/components/map/map';
import Address from '@/components/address/address';
import baseURL from '@/config/url';
import IndustryModal from './components/IndustryModal.vue';

export default {
  data() {
    return {
      loading: false,
      benefits: [
        { value: '包吃', label: '包吃' },
        { value: '包住', label: '包住' },
        { value: '餐补', label: '餐补' },
        { value: '五险', label: '五险' },
        { value: '五险一金', label: '五险一金' },
        { value: '高温补贴', label: '高温补贴' },
        { value: '年终奖', label: '年终奖' },
        { value: '保底工资', label: '保底工资' },
        { value: '房补', label: '房补' },
        { value: '周末双休', label: '周末双休' },
        { value: '8小时工作制', label: '8 小时工作制' }
      ],
      salaryPers: [
        { value: 0, label: '面议' },
        { value: 1, label: '小时' },
        { value: 2, label: '日' },
        { value: 3, label: '周' },
        { value: 4, label: '月' },
        { value: 5, label: '项目结' },
        { value: 6, label: '按件结' }
      ],
      years: [
        { label: '不限', min: 0, max: 0 },
        { label: '1年以内', min: 0, max: 1 },
        { label: '1-3年', min: 1, max: 3 },
        { label: '3-5年', min: 3, max: 5 },
        { label: '5-10年', min: 5, max: 10 },
        { label: '10年以上', min: 10, max: 0 }
      ],
      id: null,
      job: {
        headCount: 1,
        salaryPer: 4,
        salaryMin: 0,
        salaryMax: 0,
        industryIds: [],
        featureIds: []
      },
      picker: [],
      cityList: [],
      site: null,
      positions: [],
      positionsIds: [],
      oMap: false,
      isEdit: false,
      degrees: [],
      rules: {
        title: [{ required: true, message: '岗位名称不能为空', trigger: 'blur' }],
        positionId: [{ required: true, message: '岗位分类不能为空', type: 'number', trigger: 'blur' }],
        headCount: [{ required: true, message: '招聘人数不能为空', type: 'number', min: 1, trigger: 'blur' }],
        address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
        addressName: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
        salaryPer: [
          { required: true, message: '薪资不能为空', type: 'number', trigger: 'blur' },
          { required: true, validator: this.validateSalary, trigger: 'blur' }
        ],
        jd: [{ required: true, message: '岗位描述不能为空', trigger: 'blur' }],
        contactName: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '联系人电话不能为空', trigger: 'blur' }]
      },
      keyword: '',
      aiLoading: false,
      answer: '',
      disabled: false,
      tem_keyword: '',
      dialogVisible: false,
      eventSource: null,
      // 地区最低工资：包含时｜月
      districtMinSalary: {},
      new_craftsman_position: [
        { id: 1, name: '技能型' },
        { id: 2, name: '学徒制' },
        { id: 3, name: '灵活用工' }
      ],
      industry: [],
      industryIndexs: [],
      identityType: 'Company',
      industriesFlag: false,
      jobChecked: false
    };
  },
  components: {
    editor,
    Map,
    Address,
    IndustryModal
  },
  mounted() {
    this.getPositions();
    this.id = this.$route.query.id;
    this.init();
    if (this.id) {
      this.isEdit = true;
      this.jobChecked = true;
      this.getDetail(this.id);
    } else {
    }
    this.getInfo();
  },
  methods: {
    initIndustries(industry) {
      this.industry = industry;
      this.job.industryIds = industry.map(item => item.id);
    },
    selectNewCraftsmanPosition(data) {
      this.job.featureIds = this.job.featureIds || [];
      if (this.job.featureIds.includes(data.id)) {
        this.job.featureIds = this.job.featureIds.filter(item => item !== data.id);
      } else {
        this.job.featureIds.push(data.id);
      }
    },
    // selectIndustry(id) {
    //   this.job.industryIds = this.job.industryIds || [];
    //   if (this.job.industryIds.includes(id)) {
    //     this.job.industryIds = this.job.industryIds.filter(item => item.id !== id);
    //   } else {
    //     this.job.industryIds.push(id);
    //   }
    // },
    selectIndustries() {
      this.industriesFlag = true;
      const type = this.identityType;
      this.$refs.industryModal.open({ type, only: 0, maxLimit: 3, industry: this.industry });
    },
    beforeClose(e) {
      if (this.eventSource) {
        this.eventSource.close();
      }
      this.keyword = '';
      this.tem_keyword = '';
      this.answer = '';
      this.aiLoading = false;
      this.disabled = false;
    },
    aiPopup() {
      if (!this.job.position) {
        this.$Message.error({
          content: '请先选择岗位类型'
        });
        return;
      }
      this.answer = '';
      this.keyword = '';
      this.tem_keyword = '';
      if (!this.job.jd) {
        this.aiLoading = false;
        this.disabled = false;
      } else {
        this.keyword = JSON.parse(JSON.stringify(this.job.jd));
        this.aiLoading = true;
        this.aiInput();
      }
      this.dialogVisible = true;
    },
    repeat() {
      this.aiLoading = true;
      this.keyword = this.tem_keyword;
      this.answer = '';
      this.aiInput();
    },
    use() {
      this.keyword = '';
      this.tem_keyword = '';
      this.dialogVisible = false;
      this.answer = this.answer.replace(/<br\/>/g, '\n');
      this.$set(this.job, 'jd', this.answer);
    },
    isEmpty(value) {
      return value === undefined || value === null;
    },
    // 校验最低时薪和最低月薪
    checkMinSalary() {
      if (this.isEmpty(this.job.salaryMin) || this.isEmpty(this.job.salaryMax)) {
        return '薪资范围必填';
      }
      if (this.isEmpty(this.job.salaryPer) || this.isEmpty(this.job.districtId)) {
        return '';
      }
      // 小时
      const hourResult = this.job.salaryPer === 1 && Number(this.job.salaryMin) < Number(this.districtMinSalary.hourly);
      // 月
      const monthResult = this.job.salaryPer === 4 && Number(this.job.salaryMin) < Number(this.districtMinSalary.monthly);
      const aimSalaryPers = this.salaryPers.find(v => v.value === this.job.salaryPer);
      const text = (aimSalaryPers && aimSalaryPers.label) || '';

      if (hourResult) {
        return `工作地点所在地区${text}工资最低为${(this.districtMinSalary && this.districtMinSalary.hourly) || 0}`;
      } else if (monthResult) {
        return `工作地点所在地区${text}工资最低为${(this.districtMinSalary && this.districtMinSalary.monthly) || 0}`;
      } else {
        return '';
      }
    },
    aiInput() {
      this.answer = '';
      if (!this.job.position) {
        this.$Message.error({
          content: '请先选择岗位类型'
        });
        return;
      }
      if (!this.keyword) {
        this.$Message.error({
          content: '请输入关键词'
        });
        return;
      }

      this.tem_keyword = this.keyword;
      console.log(6666, this.tem_keyword);
      this.$axios
        .request({
          url: 'front/v1/dify/token',
          method: 'post',
          data: { content: JSON.stringify({ jobDesc: this.tem_keyword, jobTitle: this.job.position }) }
        })
        .then(res => {
          if (res.code === 200) {
            this.tem_keyword = this.keyword || this.job.jd;
            this.keyword = '';
            this.aiLoading = true;
            this.disabled = true;
            this.getUuid(res.data);
          }
        });
    },
    getUuid(uuid) {
      let that = this;
      that.eventSource = new EventSource(
        baseURL + 'front/v1/dify/genJD?difyToken=' + uuid
        // { withCredentials: true }
      );
      that.eventSource.onopen = function () {
        console.log('连接已经建立');
      };
      that.eventSource.onmessage = function (event) {
        let events = JSON.parse(event.data);
        if (events.event === 'message_end' || events.event === 'tts_message_end') {
          that.eventSource.close();
          that.aiLoading = false;
          that.disabled = false;
        } else {
          that.aiLoading = false;
          console.log(67565, events.answer);
          let msg = events.answer && events.answer.replace(/\\n/g, '<br/>');
          msg = msg.replace(/\n/g, '<br/>');
          that.answer += msg;
        }
      };
      that.eventSource.onerror = function (event) {
        that.answer = '系统出错，请重新输入。。。';
        that.eventSource.close();
        that.aiLoading = false;
        that.disabled = false;
        // 处理错误
      };
    },
    getInfo() {},
    chooseLocation(row) {
      this.$set(this.job, 'provinceId', row.provinceId);
      this.$set(this.job, 'cityId', row.cityId);
      this.$set(this.job, 'districtId', row.districtId);
      this.$set(this.job, 'streetId', row.streetId);
      this.$set(this.job, 'latitude', row.latitude);
      this.$set(this.job, 'longitude', row.longitude);
      this.$set(this.job, 'address', row.address);
      this.getProvinceMinSalary();
    },
    getProvinceMinSalary() {
      if (!this.job.districtId) {
        return;
      }
      this.$axios
        .request({
          url: 'front/v1/job/salary-min/' + this.job.districtId,
          method: 'get'
        })
        .then(res => {
          if (res.code === 200) {
            this.districtMinSalary = {
              hourly: res.data.hourly,
              monthly: res.data.monthly
            };
          }
        });
    },
    init() {
      this.getDicts('degree').then(res => {
        this.degrees = [];
        res.data.forEach(element => {
          element.value = parseInt(element.value);
          this.degrees.push(element);
        });
      });
      // this.$axios.request({ url: 'api/common/job_meta' }).then(res => {
      //   this.pickerList = res.data;
      // });
    },
    getDetail(id) {
      this.$axios.request({ url: 'front/v1/job/' + id }).then(res => {
        this.job = res.data;
        this.industry = this.job.industries.map(item => item.industryInfo);
        if (!this.job.workYearString) {
          this.job.workYearString = '不限';
        }
        this.getProvinceMinSalary();
        // this.getPositionIds()
        this.checkAndGetPositionIds(4);
      });
    },

    checkAndGetPositionIds(retries) {
      console.log('checkAndGetPositionIds', retries);
      console.log('checkAndGetPositionIds', this.positions);
      if (this.positions && this.positions.length > 0) {
        this.getPositionIds();
      } else if (retries > 0) {
        // 如果 positions 没有值，等待 2 秒后再次检查
        setTimeout(() => {
          this.checkAndGetPositionIds(retries - 1);
        }, 1000); // 2秒 = 2000毫秒
      } else {
        console.log('positions 在3次尝试后仍然没有值');
      }
    },
    changeWorkYear(val) {
      this.years.forEach(item => {
        if (item.label === val) {
          this.$set(this.job, 'workYearMin', item.min);
          this.$set(this.job, 'workYearMax', item.max);
        }
      });
    },
    changeDegree(e) {
      let index = this.degrees.findIndex(item => parseInt(item.value) === e);
      this.$set(this.job, 'degreeString', this.degrees[index].label);
    },
    getPositions() {
      this.$axios.request({ url: 'front/v1/position/tree' }).then(res => {
        this.positions = res.data;
        console.log('checkAndGetPositionIds getPositions', this.positions);
        this.setName(this.positions);
        if (this.id) {
          this.findAncestorIds(this.job.positionId, []);
        }
      });
    },
    setName(positions) {
      positions.map((item, index) => {
        positions[index].value = item.id;
        positions[index].label = item.name;
        if (!item.children || item.children == 0) {
          return;
        } else {
          this.setName(positions[index].children);
        }
      });
    },
    findAncestorIds(tree, targetId, ancestorIds = []) {
      if (!tree || !Array.isArray(tree)) return [];
      for (let node of tree) {
        if (node.id === targetId) {
          return ancestorIds.concat(node.id);
        }
        if (node.children) {
          const childAncestors = this.findAncestorIds(node.children, targetId, ancestorIds.concat(node.id));
          if (childAncestors.length > 0) {
            return childAncestors;
          }
        }
      }
      return [];
    },
    getPositionIds() {
      if (!this.positions || !this.job.positionId) {
        return [];
      }
      this.positionsIds = this.findAncestorIds(this.positions, this.job.positionId, []);
    },
    setPositon_name(e, selectedData) {
      let index = e.length - 1;
      this.job.positionId = e[index];
      this.job.position = selectedData[index].name;
    },
    getSite() {
      this.oMap = true;
    },
    setSite(e) {
      this.oMap = false;
      this.job.latitude = e.latlng.lat;
      this.job.longitude = e.latlng.lng;
      this.job.address = e.poiaddress;
      this.job.addressName = e.poiname;
    },
    getText(html) {
      this.job.description = html;
    },
    getText2(html) {
      this.job.demand = html;
    },
    setStatus(index) {
      let data = {
        check: index,
        job_id: this.job.id
      };
      this.$Modal.confirm({
        content: index == 1 ? '确认开启该岗位' : '确认关闭该岗位',
        onOk: () => {
          this.$axios
            .request({
              url: 'front/v1/job/status',
              method: 'put',
              data: data
            })
            .then(res => {
              if (!res.success) {
                return;
              }
              this.job.status = index;
              if (res.data.status == 0) {
                this.$Notice.success({
                  title: '关闭成功'
                });
              } else {
                this.$Notice.success({
                  title: '开启成功'
                });
              }
            });
        }
      });
    },
    validSalary() {
      if (this.job.salaryPer && !this.job.salaryMin && !this.job.salaryMax) {
        this.$Notice.error({ title: '请输入薪资范围' });
        return true;
      }
      if (this.job.salaryMax < this.job.salaryMin) {
        this.$Notice.error({ title: '请输正确的薪资范围' });
        return true;
      }
    },
    add(isDraf = false) {
      if (this.loading) {
        return;
      }

      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.validSalary()) {
            return;
          }
          if (!this.jobChecked) {
            this.$Message.error({
              content: '请阅读并同意《岗位协议》'
            });
            return;
          }
          if (isDraf) {
            this.job.status = 0;
          } else {
            this.job.status = 1;
          }
          this.loading = true;
          this.$axios
            .request({
              url: 'front/v1/job',
              method: 'post',
              data: this.job
            })
            .then(res => {
              this.$Notice.success({
                title: '保存成功'
              });
              setTimeout(() => {
                this.loading = false;
                this.$router.back(-1);
              }, 1500);
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    confirm(isDraf = false) {
      if (this.loading) {
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.validSalary()) {
            return;
          }
          if (!this.jobChecked) {
            this.$Message.error({
              content: '请阅读并同意《岗位协议》'
            });
            return;
          }
          if (isDraf) {
            this.job.status = 0;
          } else {
            this.job.status = 1;
          }
          this.loading = true;
          this.$axios
            .request({
              url: 'front/v1/job/' + this.id,
              method: 'put',
              data: this.job
            })
            .then(res => {
              this.$Notice.success({
                title: '保存成功'
              });
              setTimeout(() => {
                this.loading = false;
                this.$router.back(-1);
              }, 1000);
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    clear() {
      this.$Modal.confirm({
        content: '<p>是否确定删除该岗位</p>',
        onOk: () => {
          this.$axios.request({ url: 'api/qiye/job/' + this.id, method: 'delete' }).then(res => {
            if (!res.success) {
              return;
            }
            this.$Notice.success({
              title: '删除成功'
            });
            this.$router.back();
          });
        }
      });
    },
    validateSalary(rules, value, callback) {
      console.log('hello');
      const result = this.checkMinSalary();
      if (result) {
        return callback(new Error(result));
      } else {
        return callback();
      }
    },
    goAgreement() {
      const routeData = this.$router.resolve({
        name: 'CompanyAgreement' // 或使用 name: 'route-name'
      });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
// deep .ivu-form .ivu-form-item-label {
//   text-align: left;
// }
.edit {
  min-height: 80vh;
  color: #363e4f;
  .content {
    margin: 0 auto;
    width: 580px;
    > .title {
      font-size: 16px;
    }
    > .remark {
      opacity: 0.7;
      margin-top: 8px;
      font-size: 12px;
      padding-bottom: 16px;
    }
    /deep/ .ivu-form-item-label {
      font-size: 14px;
    }
    .site {
      width: 379px;
      border: 1px solid #dcdee2;
      border-radius: 4px;
      padding: 0 4px;
      height: 32px;
      overflow: hidden;
      white-space: nowrap;
    }
    .grey {
      color: #c5c8ce;
      font-size: 12px;
    }
    /deep/.w-e-text-container {
      height: 200px !important;
    }
    .text {
      text-align: right;
      margin-top: 40px;
      opacity: 0.45;
    }
    .fabu {
      width: 89px;
      font-size: 16px;
      float: right;
      margin-top: 21px;
      cursor: pointer;
    }
    .btn {
      display: flex;
      float: right;
      margin-top: 21px;
      font-size: 16px;
      > div {
        padding: 7px 28px;
        color: #fff;
        margin-left: 10px;
        border-radius: 4px;
        cursor: pointer;
      }
      .clear {
        color: #fd485d;
        cursor: pointer;
      }
      .close {
        background-color: #fd485d;
      }
      .open {
        background-color: #d6000f;
      }
      .confirm {
        background-color: #d6000f;
      }
    }
  }
}
.custom {
  display: inline-block;
  width: 80px;
  height: 32px;
  text-align: center;
  background: #eee;
  border-radius: 4px;
  line-height: 32px;
  margin-left: 20px;
  border: 1px solid #eee;
  color: #ccc;
  cursor: pointer;
  &.actived {
    border: 1px solid #d6000f;
    background-color: #fff;
    color: #d6000f;
  }
}
.ai-text {
  position: absolute;
  left: -90px;
  top: 30px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.ai-botttom {
  width: 100%;
  background: linear-gradient(180deg, #ffe8e8 0%, #ffffff 50%);
  padding: 20px;
  box-sizing: border-box;
  border-radius: 12px;
  .top {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .prompt {
    color: #131112;
    font-size: 14px;
  }
  .tips {
    font-size: 12px;
    color: #777;
    margin: 8px 0 12px;
  }
  .loading-img {
    text-align: center;
    height: 200px;
    color: #777777;
    font-size: 12px;
  }
  .ai-btn-right {
    display: flex;

    .ai-btn {
      width: 76px;
      height: 29px;
      line-height: 29px;
      text-align: center;
      background: linear-gradient(180deg, #ff807e 0%, #ff3c3a 100%);
      color: #fff;
      font-size: 12px;
      border-radius: 8px;
      box-sizing: border-box;
      margin-bottom: 15px;
    }
    .btn-left {
      background: #fff;
      border: 2px solid #ffe2e2;
      color: #f21b18;
      margin-left: 14px;
    }
  }
  .foot_center {
    width: 775px;
    min-height: 40px;
    border-radius: 40px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 0 4px rgba(242, 27, 24, 0.15);
    .btn_foot {
      height: 36px;
      border-radius: 29px;
      width: 55px;
      background: linear-gradient(180deg, #ff807e 0%, #ff3c3a 100%);
      margin-top: 2px;
    }
  }
}
.set-bg {
  /deep/ .ivu-modal-body {
    padding: 0;
  }
}
.ai-input {
  padding: 5px 10px;
  /deep/ .ivu-input {
    border: 0px solid #fff !important;
  }
  /deep/ .ivu-input:focus {
    outline: none;
    border: none;
    box-shadow: 0 0 0 2px transparent;
    border-bottom: 1.3px solid gainsboro;
  }
}

.hot-post-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .post-item {
    min-width: fit-content;
    padding: 0 10px;
    width: 80px;
    height: 32px;
    border-radius: 5px;
    border: 1px solid #eee;
    box-sizing: border-box;
    color: #333;
    font-size: 14px;
    text-align: center;
    line-height: 32px;
    margin-right: 16px;
  }
  .post-item::hover {
    cursor: pointer;
  }
  .zan-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
  }

  .not-done {
    background: #f3f3f3;
    border: none;
    color: #aaa;
  }
  .bill {
    background: #feeded;
    border: none;
    color: #f32926;
  }
}

.industry {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.arrow-right {
  width: 40px;
  height: 32px;
  text-align: center;
  cursor: pointer;
}
</style>
